import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { BaseApiService } from './base-api.service';
import { ExternalClientModel, ExternalClientModelPagedResponseModel } from '../models';
import { ApiConfigService } from './api-config.service';

@Injectable({
    providedIn: 'root'
})
export class ExternalClientsService extends BaseApiService {

    constructor( http: HttpClient,
        apiConfig: ApiConfigService) {
        super(http, apiConfig);
    }
    baseUrl = this.apiConfig.getBaseUrl();

    /**
     * Get all external clients with pagination
     */
    getExternalClients(page: number = 1, pageSize: number = 20): Observable<ExternalClientModelPagedResponseModel> {
        const params = new HttpParams()
            .set('page', page.toString())
            .set('pageSize', pageSize.toString());

        return this.http.get<ExternalClientModelPagedResponseModel>(`${this.baseUrl}/api/v1/external-clients`, { params });
    }

    /**
     * Get external client by ID
     */
    getExternalClient(id: string): Observable<ExternalClientModel> {
        return this.http.get<ExternalClientModel>(`${this.baseUrl}/api/v1/external-clients/${id}`);
    }

    /**
     * Create new external client
     */
    createExternalClient(externalClient: ExternalClientModel): Observable<ExternalClientModel> {
        return this.http.post<ExternalClientModel>(`${this.baseUrl}/api/v1/external-clients`, externalClient);
    }

    /**
     * Update external client
     */
    updateExternalClient(id: string, externalClient: ExternalClientModel): Observable<ExternalClientModel> {
        return this.http.put<ExternalClientModel>(`${this.baseUrl}/api/v1/external-clients/${id}`, externalClient);
    }

    /**
     * Delete external client
     */
    deleteExternalClient(id: string): Observable<void> {
        return this.http.delete<void>(`${this.baseUrl}/api/v1/external-clients/${id}`);
    }

    /**
     * Get external clients by system ID
     */
    getExternalClientsBySystem(systemId: string): Observable<ExternalClientModel[]> {
        return this.http.get<ExternalClientModel[]>(`${this.baseUrl}/api/v1/external-clients/system/${systemId}`);
    }

    /**
     * Get external client by API key
     */
    getExternalClientByApiKey(apiKey: string): Observable<ExternalClientModel> {
        return this.http.get<ExternalClientModel>(`${this.baseUrl}/api/v1/external-clients/api-key/${apiKey}`);
    }

    /**
     * Search external clients
     */
    searchExternalClients(searchTerm: string): Observable<ExternalClientModel[]> {
        return this.http.get<ExternalClientModel[]>(`${this.baseUrl}/api/v1/external-clients/search?searchTerm=${searchTerm}`);
    }

    /**
     * Update external client status
     */
    updateExternalClientStatus(id: string, isActive: boolean): Observable<void> {
        return this.http.put<void>(`${this.baseUrl}/api/v1/external-clients/${id}/status`, { isActive });
    }

    /**
     * Update external client last access date
     */
    updateExternalClientLastAccess(id: string): Observable<void> {
        return this.http.put<void>(`${this.baseUrl}/api/v1/external-clients/${id}/last-access`, {});
    }
}
